module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.messages.length > 0) ? _c('div', _vm._l((_vm.messages), function(message) {
    return _c('el-alert', {
      key: message,
      attrs: {
        "title": message,
        "type": "error",
        "show-icon": ""
      }
    })
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7423192"}!./src/components/alert/alert.html
// module id = 819
// module chunks = 1